import React from 'react';
import PropTypes from 'prop-types';
import styles from './FormSelect.module.css';

const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
  disabled = false,
  placeholder = 'Select...',
  required = true, // New prop to control asterisk display
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.selectWrapper}>
        <select
          name={name}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className={`${styles.select} ${error ? styles.selectError : ''}`}
        >
          <option value="">{placeholder}</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className={styles.selectIcon}>▼</div>
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

FormSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  required: PropTypes.bool, // New prop type
};

export default FormSelect;
